import { Tracking } from '../../utils/tracking.js';
import { escapeHtml } from '../../suggestedActions.js';

/**
 * Shared map click handler for both Google Maps and Leaflet.
 */
export function createMapClickHandler(config) {
  return (e) => {
    const link = e.target.closest('.mta-map-popup-link');
    if (link) {
      const clientName = config?.client || '';
      Tracking.trackResultClick(clientName, link.innerText || link.textContent || '', link.href);
    }
  };
}

/**
 * UI Builders for loading and error states.
 */
export function createLoadingElement(t) {
  const loadingEl = document.createElement("div");
  loadingEl.className = "mta-map-loading";
  loadingEl.setAttribute("role", "status");
  loadingEl.setAttribute("aria-live", "polite");
  loadingEl.textContent = t("map_loading");
  return loadingEl;
}

export function createErrorElement(t, retryFn) {
  const errorEl = document.createElement("div");
  errorEl.className = "mta-map-error";
  errorEl.setAttribute("role", "alert");
  errorEl.innerHTML = `
    <p>${escapeHtml(t("map_error"))}</p>
    <button type="button" class="mta-map-retry">${escapeHtml(t("map_retry"))}</button>
  `;
  errorEl.querySelector(".mta-map-retry")?.addEventListener("click", retryFn);
  return errorEl;
}
